/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { useFormik } from 'formik'
import { getUserByToken, login } from '../core/_requests'
import { useAuth } from '../core/Auth'
import { AuthModel, isSecondFactorChallenge, SecondFactorChallenge } from '../core/_models'
import { SecondFactorStep } from './SecondFactorStep'
import { loginErrorText } from '../core/loginErrors'
// import {env} from "../../../../env";

// const initialValues = {
//   email: 'admin@demo.com',
//   password: 'demo',
// }

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [loading, setLoading] = useState(false)
  const [secondFactor, setSecondFactor] = useState<SecondFactorChallenge | null>(null)
  const { saveAuth, setCurrentUser } = useAuth()

  // The token is in hand: load the person it belongs to.
  const completeLogin = async (auth: AuthModel) => {
    saveAuth(auth)
    const { data: user } = await getUserByToken(auth.auth_token)
    setCurrentUser(user.userData)

    if (!user.userData) {
      throw new Error('Не удалось извлечь информацию о пользователе.')
    }
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const { data: auth } = await login(values.email, values.password)

        if (isSecondFactorChallenge(auth)) {
          // the password alone does not sign this account in
          setSecondFactor(auth)
          setSubmitting(false)
          setLoading(false)
          return
        }

        await completeLogin(auth)
      } catch (e) {
        setStatus(loginErrorText(e))
        saveAuth(undefined)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  if (secondFactor) {
    return (
      <SecondFactorStep
        challenge={secondFactor.challenge}
        methods={secondFactor.methods}
        onSuccess={async (auth) => {
          try {
            await completeLogin(auth)
          } catch (e) {
            saveAuth(undefined)
            setSecondFactor(null)
            formik.setStatus(e instanceof Error && e.message ? e.message : 'Что-то пошло не так.')
          }
        }}
        onRestart={(message) => {
          setSecondFactor(null)
          formik.setFieldValue('password', '')
          formik.setStatus(message)
        }}
      />
    )
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Авторизация</h1>
      </div>

      {formik.status ? (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      ) : (
        ''
      )}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='form-label fs-6 fw-bolder text-dark'>Имя пользователя</label>
        <input
          {...formik.getFieldProps('email')}
          type='email'
          className='form-control bg-transparent'
          autoComplete='off'
          name='email'
        />
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-3'>
        <label className='form-label fw-bolder text-dark fs-6 mb-0'>Пароль</label>
        <input
          {...formik.getFieldProps('password')}
          type='password'
          autoComplete='off'
          className='form-control bg-transparent'
        />
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Войти</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Пожалуйста, подождите...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}
    </form>
  )
}
